<div class="detail-container" (click)="click()" (middleClick)="click(true)" [ngClass]="(link || externalLink) ? 'detail-with-link' : ''">
  <div class="detail-wrapper">
    <div class="detail-header" *ngIf="header" [innerHTML]="header">
    </div>
    <div class="detail-value">
      <mat-spinner *ngIf="loading" diameter="18"></mat-spinner>
      <ng-container *ngIf="limitedAccess">
        <span class="limited-access"><mat-icon matTooltip="Brak dostępu do danych" matTooltipPosition="above">do_not_disturb</mat-icon></span>
      </ng-container>
      <ng-container *ngIf="value && !link">
        <span (click)="copyMessage(value)">  {{value}} {{ pln ? 'PLN' : '' }} </span>
      </ng-container>
      <ng-container *ngIf="value && link">
        <span >  {{value}} {{ pln ? 'PLN' : '' }} </span>
      </ng-container>
      <div #ref><ng-content></ng-content></div>
      <ng-container *ngIf="!value && link && !ref?.innerHTML?.trim() && active">
        brak nazwy
      </ng-container>
    </div>
  </div>
</div>
